<template>
   <blank-layout>
      <v-row>
         <v-col cols="12" lg="7" xl="6" class="info d-none d-md-flex align-center justify-center">
            <v-container>
               <div class="pa-10">
                  <v-row justify="center">
                     <v-col cols="8" xl="5">
                        <div>
                           <div class="text-center">
                              <v-avatar color="white" width="150" height="150">
                                 <img src="@/assets/images/miplogo-300x300.png">
                              </v-avatar>
                           </div>
                           <br>
                           <h2 class="display-1 white--text font-weight-medium">
                              MIP Online Membership System
                           </h2>
                        </div>
                     </v-col>
                  </v-row>
               </div>
            </v-container>
         </v-col>
         <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
            <v-container>
               <div class="pa-7 pa-sm-12">
                  <v-row>
                     <v-col cols="12" lg="9" xl="6">
                        <v-row dense>
                           <v-col cols="12" sm="4" lg="2">
                              <img src="@/assets/images/logo-icon.png" />
                           </v-col>
                           <v-col cols="12" sm="8" lg="10">
                              Malaysian Institute of Planners Online Membership
                           </v-col>
                        </v-row>

                        <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">Admin Sign in</h2>

                        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                           <v-text-field
                              v-model="identity"
                              :rules="emailRules"
                              label="E-mail"
                              class="mt-4"
                              outlined
                           ></v-text-field>

                           <v-text-field
                              v-model="password"
                              :counter="15"
                              :rules="passwordRules"
                              label="Password"
                              required
                              outlined
                              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="show1 ? 'text' : 'password'"
                              @click:append="show1 = !show1"
                           ></v-text-field>

                           <div class="d-block d-sm-flex align-center mb-4 mb-sm-0">
                              <v-checkbox
                                 v-model="rememberme"
                                 label="Remember me?"
                                 required
                              ></v-checkbox>
                              <div class="ml-auto">
                                 <a href="/forgot-password" class="link">Forgot pwd?</a>
                              </div>
                           </div>

                           <v-btn
                              :disabled="!valid||submitting"
                              color="info"
                              block
                              class="mr-4"
                              submit
                              @click="submit"
                           >Sign In</v-btn>
                        </v-form>

                        <v-snackbar v-model="showerror" timeout="5000" color="red" dark centered>
                           {{ errormsg }}
                           <template v-slot:action="{ attrs }">
                              <v-btn color="blue" text v-bind="attrs" @click="showerror = false">
                                 Close
                              </v-btn>
                           </template>
                        </v-snackbar>
                     </v-col>
                  </v-row>
               </div>
            </v-container>
         </v-col>
      </v-row>
   </blank-layout>
</template>

<script>
import BlankLayout from '@/Layouts/BlankLayout.vue';

export default {
   components: { BlankLayout },
   name: "MOMAdminLogin",
   props: {
      errors: Object,
   },

   data() {
      return {
         showerror: false,
         errormsg: '',
         submitting: false,
         valid: true,
         password: '',
         show1: false,
         identity: '',
         emailRules: [
            v => !!v || "E-mail is required",
            v => /.+@.+\..+/.test(v) || "E-mail must be valid"
         ],
         passwordRules: [
            v => !!v || "Password is required",
            v => (v && v.length >= 8) || "Password must be at least 8 characters"
         ],
         rememberme: false
      }
   },

   methods: {
      submit() {
         if (this.identity === '') {
            this.errormsg = "Must provide E-mail as your login identity"
            this.showerror = true
            return
         }

         const data = {
            identity: this.identity,
            password: this.password,
            remember: this.rememberme,
            login_type: 'admin',
         }

         this.$refs.form.validate()
         if (this.$refs.form.validate(true)) {
            this.$inertia.post(this.route('login'), data, {
               onStart: () => this.submitting = true,
               onSuccess: () => {
                  window.location.replace('/dashboard')
               },
               onFinish: () => {
                  this.submitting = false
                  if (Object.keys(this.errors).length > 0) {
                     this.errormsg = ''
                     for (const itm in this.errors) {
                        this.errormsg += `${itm}: ${this.errors[itm]}`
                     }
                     this.showerror = true
                  }
               }
            })
         }
      }
   },

   mounted() {
      if (this.$page.user) {
         window.location.replace('/dashboard')
      }
   },
};
</script>
